<template>
  <div
    class="d-flex flex-column flex-root custom-dashboard-layout"
    v-if="isAuthenticated"
  >
    <KTHeaderMobile></KTHeaderMobile>
    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>
    <div class="d-flex flex-row flex-column-fluid page">
      <KTAside v-if="asideEnabled"></KTAside>
      <div id="kt_wrapper" class="d-flex flex-column flex-row-fluid wrapper">
        <KTHeader></KTHeader>
        <div id="kt_content" class="d-flex flex-column flex-column-fluid">
          <div class="d-flex flex-column-fluid">
            <div
              :class="{
                'container-fluid': contentFluid,
                container: !contentFluid,
              }"
            >
              <transition name="fade-in-up">
                <v-app>
                  <router-view />
                </v-app>
              </transition>
            </div>
          </div>
        </div>
        <KTFooter></KTFooter>
      </div>
    </div>
    <KTScrollTop></KTScrollTop>
    <vue-confirm-dialog></vue-confirm-dialog>
  </div>
</template>

<style  lang="scss">
@import "../../../assets/sass/style.vue";
@import url("https://fonts.googleapis.com/css?family=Prompt");

.custom-dashboard-layout {
  font-family: "Prompt" !important;
}
</style>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import KTAside from "@/components/admin/layout/aside/Aside.vue";
import KTHeader from "@/components/admin/layout/header/Header.vue";
import KTHeaderMobile from "@/components/admin/layout/header/HeaderMobile.vue";
import KTFooter from "@/components/admin/layout/footer/Footer.vue";
import HtmlClass from "@/core/services/htmlclass.service";
import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
import Loader from "@/components/admin/layout/Loader.vue";
import VueConfirmDialog from "vue-confirm-dialog";
Vue.use(VueConfirmDialog);
Vue.component("vue-confirm-dialog", VueConfirmDialog.default);
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
export default {
  name: "Layout",
  components: {
    KTAside,
    KTHeader,
    KTHeaderMobile,
    KTFooter,
    KTScrollTop,
    Loader,
  },
  beforeMount() {
    // show page loading
    this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
    HtmlClass.init(this.layoutConfig());
  },
  mounted() {
    if ((!this.isAuthenticated || this.currentUser.role !== "admin") && this.$route.path.indexOf("/admin/support-response") !== -1) {
      this.$router.push({ name: "login", query: { redirect: "support-response", to: this.$route.path.split("/")[3] }, });
    } else {
      if (!this.isAuthenticated || this.currentUser.role !== "admin") {
        this.$router.push({ name: "login" });
      }
    }
    setTimeout(() => {
      this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
    }, 2000);
  },
  methods: {},
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
  },
};
</script>
